import { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../services/api';

export default function VerifyPage() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const [code, setCode] = useState('');
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMsg('');
    setErr('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/verify', { email, code });
      setMsg(data.message);
    } catch (e: any) {
      setErr(e.response?.data?.message || 'Erro ao verificar código');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Confirmar Cadastro</h1>
        <p className="text-sm text-gray-500 mb-6">
          Enviamos um código de verificação para <strong>{email}</strong>
        </p>
        {err && <div className="bg-red-50 text-red-700 p-3 rounded-md text-sm mb-4">{err}</div>}
        {msg && (
          <div>
            <div className="bg-green-50 text-green-700 p-3 rounded-md text-sm mb-4">{msg}</div>
            <Link to="/login" className="text-primary-600 hover:text-primary-700 text-sm font-medium">
              Ir para o login
            </Link>
          </div>
        )}
        {!msg && (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Código de Verificação</label>
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                required
                maxLength={6}
                placeholder="000000"
                className="w-full text-center text-2xl tracking-[8px] px-3 py-2 border border-gray-300 rounded-md"
              />
            </div>
            <button type="submit" disabled={loading || code.length < 6}
              className="w-full bg-primary-600 hover:bg-primary-700 text-white font-medium py-2 px-4 rounded-md disabled:opacity-50">
              {loading ? 'Verificando...' : 'Confirmar'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
